/* UploadSignedAddendumModal — thin wrapper around the shared
 * `RecordExternalExecutionModal`, parameterised for the WS5
 * appointment-addendum external-upload endpoint.
 *
 * Keeps the multi-file upload UX (10-file cap, signer evidence,
 * method summary, external reference) identical to the three
 * sibling surfaces (WS3 agreement, WS5 contract, WS5 appointment,
 * WS6 change) so admin muscle-memory carries across.
 */
import React from "react";
import { toast } from "sonner";
import { API } from "../../lib/api";
import RecordExternalExecutionModal from "./RecordExternalExecutionModal";

export default function UploadSignedAddendumModal({
    open, onClose, projectId, appointmentId, onSuccess,
}) {
    return (
        <RecordExternalExecutionModal
            open={open}
            onClose={onClose}
            endpointUrl={`${API}/admin/projects/${projectId}/ws5/appointments/${appointmentId}/addenda/upload-signed`}
            submitLabel="Upload Signed Addendum"
            helpText={"Attach the externally-signed Appointment Addendum PDF and capture structured signer evidence. "
                      + "The uploaded PDF becomes the authoritative executed addendum document; "
                      + "the addendum is recorded directly in Executed status."}
            testIdPrefix={`ws5-apt-${appointmentId}-upload-addendum`}
            onSuccessData={async () => {
                toast.success("Signed addendum uploaded and executed.");
                if (typeof onSuccess === "function") {
                    await onSuccess();
                }
            }} />
    );
}
